export const supportedImageCdnPlugins = [
  { name: `gatsby-source-sanity`, version: `7.4.2` },
  { name: `gatsby-source-wordpress`, version: `6.16.1` },
  { name: `gatsby-source-drupal`, version: `5.17.1` },
  { name: `gatsby-source-contentful`, version: `7.14.0` },
]
